export default function OtherMetaTags(): JSX.Element {
  return (
    <>
      <meta name='keywords' content='Celebrities, Shoutout, Yela' />
      <meta name='author' content='Yela' />
    </>
  );
}
